import { render, staticRenderFns } from "./packaging-data-card.vue?vue&type=template&id=70451bfc&scoped=true"
import script from "./packaging-data-card.vue?vue&type=script&lang=js"
export * from "./packaging-data-card.vue?vue&type=script&lang=js"
import style0 from "./packaging-data-card.vue?vue&type=style&index=0&id=70451bfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70451bfc",
  null
  
)

export default component.exports